import * as SvgIcons from '../../elements/svgIcons'

const iconsObj: {
    [key: string]: any
} = {
    DashboardIcon: SvgIcons.DashboardIcon,
    BriefcaseIcon: SvgIcons.BriefcaseIcon,
    UserIcon: SvgIcons.UserIcon,

};


export default [
    {
        "label": "Home",
        "icon": iconsObj["DashboardIcon"],
        "to": "/dashboard",
        "className": 'dashboard-icon'
    },
    {
        "label": "Find a lawyer",
        "icon": iconsObj["BriefcaseIcon"],
        "to": "/find-lawyer",
        "className": 'briefcase-icon'
    },
    {
        "label": "Profile",
        "icon": iconsObj["UserIcon"],
        "to": "/profile",
        "className": 'user-icon'
    }
]
